import { isMobile } from '@utils/window';

import { LatLngBounds, LatLngTuple } from '@typings/geo';

export const defaultZoom = isMobile() ? 7 : 8;
export const defaultCenter: LatLngTuple = [49.817785, 15.309794];
export const maxBounds: LatLngBounds = [
  [48.447422, 9.6295166],
  [51.2063611, 20.8795166],
];
export const maxZoom = 20;
export const minZoom = 6;
